import { request } from '@/api/service'

/**
 * 会议列表
 */
export function GetMeetingList(obj) {
   return request({
      url: 'respool_cli/client_admin/meetings/query/sync/',
      method: 'post',
      data: obj,
   })
}

/**
 * 订单列表
 */
export function GetOrdersList(obj) {
   return request({
      url: 'respool_cli/client_admin/client/orders/state/sync/',
      method: 'post',
      data: obj,
   })
}

/*
 * 获取前端配置文件
 */
export function getConfigJson(query) {
   let url = ''
   if (process.env.NODE_ENV != 'development') {
      url = `${location.origin}/h5/config.json?random=${Math.random()}`
   } else {
      url = `${location.origin}/config.json?random=${Math.random()}`
   }
   return request({
      url: url,
      method: 'get',
      params: query,
   })
}
